export class Calculator {

    constructor() {
        this.price_glass = 0;
        this.calc_glass = 1;
        this.calc_fastening = 1;
        this.calc_del = 1;
        this.calc_elevator = 1;
        this.calc_print = 0;
        this.delivery = 0;
        this.price_fastening = 0;
        this.count = 0;
    }

    add()
    {
        $('ol.calculator-form__size-list').append(`<li class="calculator-form__size-item"><div class="calculator-form__size-element"><input class="lenght form__input" oninput="calculator.check(this)" type="text" placeholder="Длина в мм" name="length-${this.count}"></div><div class="calculator-form__size-x">x</div><div class="calculator-form__size-element"><input class="height form__input" oninput="calculator.check(this)" type="text" placeholder="Высота в мм" name="height-${this.count}"></div><button onclick="calculator.delete(this)" class="calculator-form__size-delete" type="button"></button></li>`)
        this.count++;
    }

    delete(obj)
    {
        obj.closest('li.calculator-form__size-item').remove()
        this.total()
    }

    check(object)
    {
        if(object.name == 'calc_print') {
            if(object.checked) {
                this[object.name] = Number(object.value);
            } else {
                this[object.name] = 0;
            }
        } else {
            this[object.name] = Number(object.value);
        }
        this.total();
    }

    total()
    {
        let result = 0;

        if(this.calc_glass == 1) {
            this.price_glass = window.clear;
            if(this.calc_print == 1) {
                this.price_glass = window.clear_print;
            }
        }
        if(this.calc_glass == 2) {
            this.price_glass = window.optiwhite;
            if(this.calc_print == 1) {
                this.price_glass = window.optiwhite_print;
            }
        }

        if(this.calc_fastening == 1) {
            this.price_fastening = window.glue_install;
        }
        if(this.calc_fastening == 2) {
            this.price_fastening = window.st_install;
        }

        if(this.calc_del == 2) {
            if(this.distance) {
                let distance = Math.ceil(this.distance / 10) * 10;
                this.delivery = distance / 10 * window.delivery;
            }
        } else {
            this.delivery = 0;
        }

        let windows = 0;
        // let i = 0;
        // let temp = 0;
        $('ol.calculator-form__size-list > li').each(function(){
            // let temp = 0;
            let lenght = $(this).find('.lenght').val() ? $(this).find('.lenght').val() : 0;
            let height = $(this).find('.height').val() ? $(this).find('.height').val() : 0;
            windows += (lenght / 1000) * (height / 1000);
            // console.log(windows)
            // i++;
            // if(temp != 0) {
            //     if(temp < 1) {
            //         temp = 1;
            //     }
            //     windows += temp;
            //     i++;
            // }
        });

        // if(windows != 0) {
        //     if(windows < 1) {
        //         windows = 1;
        //     }
        //     windows += temp;
        //     i++;
        // }

        // windows = windows.toFixed(1);

        if(windows != 0) {
            if(windows < 1) {
                windows = 1;
            }
            result += windows * this.price_glass;
            result += this.delivery;
            result += this.price_fastening * windows;
            // result += this.price_fastening * i;
            if(this.blocks) {
                result += this.blocks * window.block;
            }
            if(this.holes) {
                result += this.holes * window.hole;
            }
            if(this.calc_elevator == 2) {
                if(this.elevator) {
                    result += this.elevator * window.lifting;
                }
            }
        }

        $('.calculator-form__price-value').html('');
        $('.calculator-form__price-value').prepend(result.toFixed(2) + '₽');

        $('.calculator-form__price-new').html('');
        $('.calculator-form__price-new').prepend((result*0.9).toFixed(2) + '₽');

    }
    
    data(data)
    {
        let result = [];
        for (const d in data) {
            if (/length/i.test(data[d].name)) data[d].name = 'Длина панели, мм';
            if (/height/i.test(data[d].name)) data[d].name = 'Высота панели, мм';
            switch (data[d].name) {
                case 'calc_glass':
                    data[d].name = 'Вид стекла';
                    break;
                case 'blocks':
                    data[d].name = 'Количество блоков розеток, шт.';
                    break;
                case 'holes':
                    data[d].name = 'Дополнительные отверстия, шт.';
                    break;
                case 'calc_print':
                    data[d].name = 'Печать на стекле';
                    break;
                case 'calc_fastening':
                    data[d].name = 'Тип крепления';
                    break;
                case 'calc_del':
                    data[d].name = 'Доставка';
                    break;
                case 'distance':
                    data[d].name = 'Расстояние, км';
                    break;
                case 'calc_elevator':
                    data[d].name = 'Подъём';
                    break;
                case 'elevator':
                    data[d].name = 'Этаж';
                    break;

            }
            let val = '';
            data[d].label ? val = data[d].label : val = data[d].value;
            result.push(
                {
                    name: data[d].name,
                    value: val
                }
            );
        } 
        return result;
    }

}